module.exports = __webpack_public_path__ + "img/Media-coverage-600x400.f8d29416.png";